/**
 * 会议管理 - 会议创建
 *
 * @file create.js
 * @author yangwei(yangwei14@baidu.com)
 */
import {Component} from 'san';

import {asPage} from '../../helper';
import {redirect} from '../../common/utils';
import MeetingContent from '../../components/meeting-config';
import {Icon} from '@baiducloud/bce-ui';
import {html} from '../../common/raw';

@asPage('/meeting/create')
export default class extends Component {
    static components = {
        'ui-content': MeetingContent,
        'ui-icon': Icon
    }
    static template = html`
    <template>
        <div class="list-content meeting-schedule">
            <div class="create-header">
                <div class="return" on-click="returnList">
                    <ui-icon name="arrow-left" />返回会议列表
                </div>
                {{'预约会议'}}
            </div>
            <ui-content route="{=route=}" />
        </div>
    `;
    returnList() {
        redirect('#/meeting/list');
    }
}
